import React, { useMemo } from 'react';
import useUserMetaData from 'wb-reddit/app/common/hooks/useUserMetaData';
import {
	DashboardIcon,
	ReportsIcon,
	SideMenu,
	useOpen,
	AdvertisersIcon,
	TeamsIcon,
	UsersIcon,
	SidemMenuNavigation,
} from '@aleph/shared-components';
import UpdateSelfOverlay from 'wb-reddit/app/common/components/updateSelfOverlay';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserAccountLevel } from 'wb-spotify/graphql/authgraph/generated';
import { SPOTIFY_ADVERTISERS_ROUTE_ALLOWED_ROLES } from 'wb-spotify/app/common/utils';

interface IProps {
	logout: () => Promise<void>;
}

const RedditSideMenu = ({ logout }: IProps) => {
	const platformUser = useUserMetaData();
	const [selfUpdateOpen, { onOpen: onSelfUpdateOpen, onClose: onSelfUpdateClose }] = useOpen(false);
	const navigate = useNavigate();

	const sideMenuConfig: SidemMenuNavigation = useMemo(() => (
		[
			{
				items: [
					{
						id:            1,
						name:          'Dashboard',
						icon:          DashboardIcon,
						path:          '/superGrid',
						hasPermission: true,
					},
					// {
					// 	id:      3,
					// 	name:    'Account',
					// 	icon:    AccountIcon,
					// 	path:	   '/account',
					// 	subMenu: [
					// 		{ id: 4, name: 'Intergrations', path: 'integrations' },
					// 		{ id: 5, name: 'Automations', path: 'automations' },
					// 	],
					// },
					{
						id:            2,
						name:          'Reports',
						icon:          ReportsIcon,
						path:          '/reports',
						hasPermission: true,
					},
				],
			},
			{
				items: [
					{
						id:            3,
						name:          'Advertisers',
						icon:          AdvertisersIcon,
						path:	         '/advertisers',
						hasPermission: SPOTIFY_ADVERTISERS_ROUTE_ALLOWED_ROLES.includes(platformUser?.userAccountLevel as unknown as UserAccountLevel),
					},
					{
						id:            6,
						name:          'Teams',
						icon:          TeamsIcon,
						path:          '/teams',
						hasPermission: true,
					},
					{
						id:            8,
						name:          'Users',
						icon:          UsersIcon,
						path:          '/users',
						hasPermission: true,
					},
				],
			},
		].map(item => ({
			...item,
			items: item.items.filter(jtem => jtem.hasPermission),
		}))
	), [platformUser]);

	return (
		<>
			<SideMenu
				avatarUrl={platformUser?.userProfilePictureUrl ?? ''}
				logout={logout}
				menu={sideMenuConfig}
				onUserClick={onSelfUpdateOpen}
				navigate={navigate}
				useLocation={useLocation}
			/>
			{
				selfUpdateOpen
        && <UpdateSelfOverlay onClose={onSelfUpdateClose} />
			}
		</>
	);
};

export default RedditSideMenu;
